import { toHalfWidth } from "~/utils/ExtendFunctions"

export const Validator = {
  maxLen: (e: any, maxLen: number) => {
    const value: string = e.target.value
    if (value.length > maxLen) {
      e.target.value = value.slice(0, maxLen)
    }
  },
  numCheck: (e: any) => {
    const value = toHalfWidth(e.target.value)
    e.target.value = value.replace(/[^0-9]/, "")
  },
  mailCheck: (value: string) => (/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/).test(value),
  // @see https://dev-gitlab.broadleaf.jp/blcloud-webfrontend-spa/bl-contract-app/-/blob/develop/src/app/module/utility/custom-validator.ts#L17
  telCheck: (value: string) => new RegExp("^([0-9]{1,4}|=|-|\\+|/|\\.|\\*)[0-9]{1,4}([0-9]{1,4}|=|-|\\+|/|\\.|\\*)" +
    "[0-9]{1,4}([0-9]{1,4}|=|-|\\+|/|\\.|\\*)[0-9]{1,4}([0-9]{1,4}|=|-|\\+|/|\\.|\\*)" +
    "[0-9]{1,4}([0-9]{1,4}|=|-|\\+|/|\\.|\\*)$").test(value),
}
